<app-header></app-header>
<div class="contenedor_principal">
    <app-menu-alterno></app-menu-alterno>
    <div class="contenidoDivTitulo">
        <div class="div-titulo-seccion">
            <h1 class="h1-titulo-app">Servicios web Banco de la República</h1>
        </div>
        <div class="div-linea-titulo"></div>
    </div>
    
    <div id="accordion" class="opcion-menu-accordion ui-accordion ui-widget ui-helper-reset" role="tablist">
        <cdk-accordion class="accordion-container">
            <cdk-accordion-item *ngFor="let dato of listaDataAccordion; let index=index;"
                #accordionItem="cdkAccordionItem" role="button" tabindex="0" [attr.id]="'accordion-header-' + index"
                [attr.aria-expanded]="accordionItem.expanded" [attr.aria-controls]="'accordion-body-' + index">
                <div class="accordion-item-header {{accordionItem.expanded ? 'is-active' : 'not-active'}}" (click)="accordionItem.toggle()">
                    {{ dato.nombre}}
                    <mat-icon *ngIf="!accordionItem.expanded" class="mat-icon-add">add</mat-icon>
                    <mat-icon *ngIf="accordionItem.expanded" class="mat-icon-remove">remove</mat-icon>
                    
                </div>
                <div role="region" class="accordion-item-content" [style.display]="accordionItem.expanded ? '' : 'none'"
                    [attr.id]="'accordion-body-' + index" [attr.aria-labelledby]="'accordion-header-' + index">
                    <div *ngFor="let hijo of dato.menuHijos; let idiceHijo=index;">
                        <div class="div-titulo">
                            <a href="{{hijo.enlace_pagina_externa}}" target="_blank">{{hijo.nombre}}</a>
                        </div>

                        
                    </div>
                </div>
            </cdk-accordion-item>
        </cdk-accordion>
    </div>
</div>